import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-rooam-black flex items-center justify-center px-4">
      <Card className="bg-rooam-gray-medium border-rooam-gray-light max-w-md w-full">
        <CardContent className="p-8 text-center">
          <XCircle className="h-16 w-16 text-yellow-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h2>
          <p className="text-gray-400 mb-6">
            Your payment was cancelled. No charges were made.
          </p>
          <div className="space-y-3">
            <Button className="bg-rooam-blue hover:bg-rooam-blue-light text-black font-semibold w-full" asChild>
              <Link to="/dashboard">Return to Dashboard</Link>
            </Button>
            <Button variant="outline" className="border-rooam-gray-light text-gray-300 w-full" asChild>
              <Link to="/browse">Browse Games</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
